import { useContext } from 'react';
import { AuthenticationContext, AuthenticationContextProps } from '../auth/components/AuthenticationContext';

export function useAuthenticatedContext(): AuthenticationContextProps {
    return useContext(AuthenticationContext);
}
